import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MdArrowDownward, MdArrowUpward } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import "./portfolio.scss";
import { useDispatch, useSelector } from "react-redux";
import { portfolioApi } from "../redux/features/portfolio/portfolioSlice";
import { Skeleton } from "@mui/material";

const Portfolio = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { portfolioTitle } = t("portfolioPage");

  const { data, error, loading } = useSelector((state) => state.portfolioSlice);

  // AUGMONT=========
  const {
    currentAmount: augGoldCurrentAmt,
    investedAmount: augGoldInvAmt,
    percent: augGoldPercent,
    profitORloss: augGoldPL,
    balQuantity: augGoldBalance,
  } = data?.[0]?.augmont?.gold || {};

  const {
    currentAmount: augSilverCurrentAmt,
    investedAmount: augSilverInvAmt,
    percent: augSilverPercent,
    profitORloss: augSilverPL,
    balQuantity: augSilverBalance,
  } = data?.[0]?.augmont?.silver || {};

  // MMTC===========
  const {
    currentAmount: mmtcCurrentAmt,
    investedAmount: mmtcInvestedAmt,
    percentNew: mmtcPercent,
    profitORloss: mmtcPL,
  } = data?.[0]?.gold || {};

  const {
    currentAmountSilver,
    investedAmountSilver,
    percentSilver,
    profitORlossSilver,
  } = data?.[0]?.silver || {};

  useEffect(() => {
    // callPortfolioAPI();
    dispatch(portfolioApi());
  }, []);

  // const portfolioData = [
  //   {
  //     img: "/images/gold_shield.png",
  //     title: "Gold",
  //     investValue: goldApi.investedAmount,
  //     currentValue: goldApi.currentAmount,
  //     inLocker: goldApi.balQuantity,
  //     profitLossValue: goldApi.profitORloss,
  //     percentValue: goldApi.percent,
  //   },
  //   {
  //     img: "/images/silver_shield.png",
  //     title: "Silver",
  //     investValue: silverApi.investedAmount,
  //     currentValue: silverApi.currentAmount,
  //     inLocker: silverApi.balQuantity,
  //     profitLossValue: silverApi.profitORloss,
  //     percentValue: silverApi.percent,
  //   },
  // ];

  const portfolioData = [
    {
      img: "/images/gold_shield.png",
      title: "Gold",
      investValue: augGoldInvAmt,
      currentValue: augGoldCurrentAmt,
      inLocker: augGoldBalance,
      profitLossValue: augGoldPL,
      percentValue: augGoldPercent,
    },
    {
      img: "/images/silver_shield.png",
      title: "Silver",
      investValue: augSilverInvAmt,
      currentValue: augSilverCurrentAmt,
      inLocker: augSilverBalance,
      profitLossValue: augSilverPL,
      percentValue: augSilverPercent,
    },
  ];

  const mmtcPortfolioData = [
    {
      img: "/images/gold_shield.png",
      title: "Gold",
      investValue: mmtcInvestedAmt,
      currentValue: mmtcCurrentAmt,
      inLocker: data?.[0]?.balances?.[0]?.balQuantity || "0.0000",
      profitLossValue: mmtcPL,
      percentValue: mmtcPercent,
    },
    {
      img: "/images/silver_shield.png",
      title: "Silver",
      investValue: investedAmountSilver,
      currentValue: currentAmountSilver,
      inLocker: data?.[0]?.balances?.[1]?.balQuantity || "0.0000",
      profitLossValue: profitORlossSilver,
      percentValue: percentSilver,
    },
  ];

  return (
    <main className="Portfolio">
      <h2 style={{ marginBottom: "1rem" }}>{portfolioTitle}</h2>
      {loading ? (
        <div className="skeleton_container">
          {Array.from({ length: 4 }).map((_, index) => (
            <div key={index} style={{ display: "flex", gap: "1rem" }}>
              <Skeleton
                variant="circular"
                // width="100%"
                height="auto"
                animation="wave"
                sx={{ maxWidth: "7rem", width: "100%" }}
              />
              <div style={{ width: "100%" }}>
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
                <Skeleton animation="wave" width="50%" />
              </div>
            </div>
          ))}
        </div>
      ) : (
        <>
          <section style={{ marginBottom: "2rem" }}>
            {/* <h2 style={{ marginBottom: "1rem" }}>AUGMONT</h2> */}
            <div className="portfolio_container">
              {/* GOLD CARD=================  */}
              {portfolioData.map(
                (
                  {
                    img,
                    title,
                    investValue,
                    currentValue,
                    inLocker,
                    profitLossValue,
                    percentValue,
                  },
                  i
                ) => (
                  <div key={i} className="portfolio_card universal_card">
                    <div
                      style={{
                        width: "30%",
                        alignItems: "center",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <img src={img} width={"100%"} alt="Gold" />
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        flexDirection: "column",
                        width: "100%",
                        gap: "1rem",
                      }}
                    >
                      <div
                        style={{
                          textAlign: "center",
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div
                          style={{
                            // fontSize: "1.4rem",
                            fontWeight: "bold",
                          }}
                        >
                          Digital {title}
                        </div>
                        <p>₹{investValue == "NaN" ? "0" : investValue}</p>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div>
                          <strong>Current Value</strong>
                          <p>
                            {currentValue == "0.00" ? "--" : `₹${currentValue}`}
                          </p>
                          {currentValue != "0.00" && (
                            <div
                              className={`${
                                parseFloat(profitLossValue) >= 0
                                  ? "positive"
                                  : "negative"
                              }`}
                              style={{
                                fontSize: "14px",
                                color: profitLossValue > 0 ? "green" : "red",
                              }}
                            >
                              {parseFloat(profitLossValue) > 0 ? (
                                <MdArrowUpward />
                              ) : (
                                <MdArrowDownward />
                              )}
                              {Math.abs(profitLossValue)} ({percentValue}%)
                            </div>
                          )}
                        </div>
                        <div
                          style={{
                            textAlign: "right",
                          }}
                        >
                          <strong>{title} in Locker</strong>
                          <p style={{ fontWeight: "bold" }}>{inLocker} gms</p>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              )}
            </div>
          </section>
          {/* <section>
            <h2 style={{ margin: "1rem 0" }}>MMTC</h2>
            <div className="portfolio_container">
              {mmtcPortfolioData.map(
                (
                  {
                    img,
                    title,
                    investValue,
                    currentValue,
                    inLocker,
                    profitLossValue,
                    percentValue,
                  },
                  i
                ) => (
                  <div key={i} className="portfolio_card universal_card">
                    <div
                      style={{
                        width: "30%",
                        alignItems: "center",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <img src={img} width={"100%"} alt="Gold" />
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        flexDirection: "column",
                        width: "100%",
                        gap: "1rem",
                      }}
                    >
                      <div
                        style={{
                          textAlign: "center",
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div
                          style={{
                            // fontSize: "1.4rem",
                            fontWeight: "bold",
                          }}
                        >
                          Digital {title}
                        </div>
                        <div>
                          ₹
                          {investValue == "NaN" || investValue === null
                            ? "0"
                            : investValue}
                        </div>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div>
                          <strong>Current Value</strong>
                          <div>
                            {currentValue == "0.00" || currentValue == null
                              ? "--"
                              : `₹${currentValue}`}
                          </div>
                          {currentValue != "0.00" ||
                            (currentValue != null && (
                              <div
                                className={`${
                                  parseFloat(profitLossValue) >= 0
                                    ? "positive"
                                    : "negative"
                                }`}
                                style={{
                                  color: profitLossValue > 0 ? "green" : "red",
                                }}
                              >
                                {parseFloat(profitLossValue) > 0 ? (
                                  <MdArrowUpward />
                                ) : (
                                  <MdArrowDownward />
                                )}
                                {Math.abs(profitLossValue)} ({percentValue}
                                %)
                              </div>
                            ))}
                        </div>
                        <div
                          style={{
                            textAlign: "right",
                          }}
                        >
                          <strong>{title} in Locker</strong>
                          <div>
                            {inLocker} gms
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              )}
            </div>
          </section> */}
        </>
      )}
    </main>
  );
};

export default Portfolio;
